/**
 * Detect whether the given seat collection belongs to a Privileged
 * Seat trip. The signal is a truthy per-seat `rgb_color` (or
 * camelCase `rgbColor`) on at least one seat. Only IAMSA emits this
 * field today, so its presence is sufficient.
 *
 * @param {Array} input - Flat array of seats, a 2D layout (rows × seats),
 *   or nullish. The function flattens shallowly and tolerates either shape.
 * @returns {boolean} True when at least one seat carries `rgb_color`.
 */
export default function hasPrivilegedSeats(input) {
  if (!input || !Array.isArray(input)) return false;

  const flat = Array.isArray(input[0]) ? input.flat(Infinity) : input;

  return flat.some((seat) => {
    if (!seat) return false;
    const color = seat.rgb_color ?? seat.rgbColor;
    return Boolean(color);
  });
}
